export const status = {
  IN_PROGRESS: 0,
  SUCCESS: 200,
  FAILURE: 400,
};
